const table = [    
  {
    prop: 'name',
    label: 'Nombre',
    minWidth: 200
  },
]

const table_plus = [    
  {
    prop: 'uri',
    label: 'Uri',
    minWidth: 200
  },
  {
    prop: 'guard_name',
    label: 'Nombre de Guardia',
    minWidth: 200
  },
  {
    prop: 'roles_names',
    label: 'Perfiles Asociados',
    minWidth: 200
  },
]

export default [table, table_plus]